import { stopService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, stops: [], stop: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        stopService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        stopService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/stops');
                    dispatch('alert/success', "Stop Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/stops');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        stopService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/stops');
                    dispatch('alert/success', "Stop Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/stops');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        stopService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      stopService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/stops');
                  dispatch('alert/success', "Stop Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/stops');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_stop_by_account({ dispatch, commit }, data) {
        commit('request');

        stopService.get_stop_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_stop_by_route({ dispatch, commit }, data) {
        commit('request');

        stopService.get_stop_by_route(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  stops: state => {
    return state.stops
  },
  stop: state => {
    return state.stop
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.stop = {};
        state.stops = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.stop = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.stops = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const stops = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
